import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'app-sla-respected-view',
  templateUrl: './sla-respected-view.component.html',
  styleUrls: ['./sla-respected-view.component.css']
})
export class SlaRespectedViewComponent implements ViewCell, OnInit {
  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

 

  constructor(){}

  ngOnInit() {
  }
  
  viewRespected(){
    let res:boolean = false;
    if(this.rowData && this.rowData.slaState && this.rowData.slaState=="Respected"){
      res=true;
    }
    return res;
  }

  

}

